import { render, staticRenderFns } from "./AnimatedIcon.vue?vue&type=template&id=103b2301&"
import script from "./AnimatedIcon.vue?vue&type=script&lang=js&"
export * from "./AnimatedIcon.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports